import {Injectable} from '@angular/core';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ProjectService} from '../../../../../../shared/services/project/project.service';

@Injectable({
    providedIn: 'root'
})
export class VSensorService {

    projectLocations: any[];
    private fetchingProjectLocations: boolean;
    private integerValidator = (control: AbstractControl) => isNaN(control.value) ? {'not a number': true} : null;
    private correctValueValidator = (control: AbstractControl) => 'string' === typeof control.value ? ({'incorrect value': true}) : null;

    constructor(protected formBuilder: FormBuilder,
                protected projectService: ProjectService) {
    }

    locationControlFactory(locationParams?, disableForm = false) {
        // condition needed because for some reasons (apparently angular issue) the form
        // builder does not work with a disabled property set to false
        if (!disableForm) {
            return this.formBuilder.group({
                location_const: [locationParams ? locationParams.location_const : 1,
                    [Validators.required, this.integerValidator]],
                location_1: [locationParams ? locationParams.location_1 : '',
                    [Validators.required, this.correctValueValidator]],
                exp_1: [locationParams ? locationParams.exp_1 : 1,
                    [Validators.required, this.integerValidator]],
                location_2: [locationParams ? locationParams.location_2 : '',
                    [Validators.required, this.correctValueValidator]],
                exp_2: [locationParams ? locationParams.exp_2 : 1,
                    [Validators.required, this.integerValidator]]
            });
        } else {
            return this.formBuilder.group({
                location_const: [
                    {
                        value: locationParams ? locationParams.location_const : 1,
                        disabled: true
                    }
                    , [Validators.required, this.integerValidator]],
                location_1: [
                    {
                        value: locationParams ? locationParams.location_1 : 1,
                        disabled: true
                    }
                    , [Validators.required, this.correctValueValidator]],
                exp_1: [
                    {
                        value: locationParams ? locationParams.exp_1 : '',
                        disabled: true
                    }
                    , [Validators.required, this.integerValidator]],
                location_2: [
                    {
                        value: locationParams ? locationParams.location_2 : 1,
                        disabled: disableForm
                    }
                    , [Validators.required, this.correctValueValidator]],
                exp_2: [
                    {
                        value: locationParams ? locationParams.exp_2 : '',
                        disabled: true
                    }
                    , [Validators.required, this.integerValidator]],
            });
        }
    }

    VSensorParamFormFactory(deviceParams?, disableForm = false): FormGroup {
        const VSensorParamForm = new FormGroup({});
        VSensorParamForm.addControl('const',
            new FormControl({
                    value: deviceParams ? deviceParams.const : 1,
                    disabled: disableForm
                }
                , [Validators.required, this.integerValidator]));
        VSensorParamForm.addControl('locations', new FormArray([]));
        if (deviceParams && deviceParams.locations && deviceParams.locations.length > 0) {
            deviceParams.locations.forEach(
                (locationParams) =>
                    (<FormArray>VSensorParamForm.get('locations')).push(this.locationControlFactory(locationParams, disableForm))
            );
        } else {
            (<FormArray>VSensorParamForm.get('locations')).push(this.locationControlFactory());
        }
        return VSensorParamForm;
    }

    fetchAndStoreProjectLocations(projectId, locationToExcludeId) {
        if (this.fetchingProjectLocations) {
            return;
        }
        this.fetchingProjectLocations = true;
        this.projectService.getProject(projectId, 'locations')
            .subscribe(
                (project: any) => {
                    this.projectLocations = project.project_device_locations
                        .filter(
                            (location) => parseInt(location.id, 10) !== parseInt(locationToExcludeId, 10))
                        .sort(
                            (location_1, location_2) => {
                                if (location_1.name) {
                                    return location_1.name.localeCompare(location_2.name);
                                } else {
                                    return -1;
                                }
                            });
                    this.fetchingProjectLocations = false;
                },
                () => this.fetchingProjectLocations = false
            );
    }

    resetProjectLocations() {
        this.projectLocations = undefined;
    }

}
